import * as yup from "yup";

export const hotelReviewSchema = yup.object({
  _id: yup.string().required("Please select your hotel name!"),
});
